// extracted by mini-css-extract-plugin
export default {"container":"RightSide_container__nU2Yj"};